import { StdResponse, bimAxios } from "@/config/axios"
import { Cable } from "@/commons/interface/device/cable";

export function getCables(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/project/${projectUuid}/cables`, {
        params: {
            ...params,
        }
    })
}

export function getCableDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/cables/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createCable(data: Cable, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/cables`, data, {
        params: {
            ...params,
        }
    })
}

export function updateCable(id: number, data: Cable, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/cables/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteCableByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/primitives/${primitiveUuid}/delete-cable`, {
        params: {
            ...params,
        }
    })
}

export function deleteCable(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/cables/${id}`, {
        params: {
            ...params,
        }
    })
}

export function deleteCables(data: number[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/cables/delete-multi`, data, {
        params: {
            ...params,
        }
    })
}

export function getCableByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/primitives/${primitiveUuid}/cables`, {
        params: {
            ...params,
        }
    })
}

export function changeCableConnect(data: Cable, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/cables/change-connect`, data, {
        params: {
            ...params,
        }
    })
}